import { Checkbox } from "../../../../../../styles/page";
import { usePosterContext } from "../../../../context/poster-context";
import { EditLine } from "../../styles";
import {
  MainInfoSectionItem,
  MainInfoSectionWrapper,
  MainInfoWrapper,
  MainInfoHeaderItem,
  MainInfoHeader,
  MainInfoContentItem,
  MainInfoContentWrapper,
  MainInfoContentItemInput,
} from "../main-info/styles/main-info.style";

const Structure = () => {
  const {
    structureSection,
    setStructureSection,
    showLevel,
    setShowLevel,
    levelLabel,
    setLevelLabel,
    showSmallBlind,
    setShowSmallBlind,
    smallBlindLabel,
    setSmallBlindLabel,
    showBigBlind,
    setShowBigBlind,
    bigBlindLabel,
    setBigBlindLabel,
    showAnte,
    setShowAnte,
    anteLabel,
    setAnteLabel,
    showDuration,
    setShowDuration,
    durationLabel,
    setDurationLabel,
    breakText,
    setBreakText,
    breakTime,
    setBreakTime,
  } = usePosterContext();

  const items = [
    {
      key: "showLevel",
      data: showLevel,
      setData: setShowLevel,
      label: levelLabel,
      setLabel: setLevelLabel,
      text: "레벨",
    },
    {
      key: "showSmallBlind",
      data: showSmallBlind,
      setData: setShowSmallBlind,
      label: smallBlindLabel,
      setLabel: setSmallBlindLabel,
      text: "스몰 블라인드",
    },
    {
      key: "showBigBlind",
      data: showBigBlind,
      setData: setShowBigBlind,
      label: bigBlindLabel,
      setLabel: setBigBlindLabel,
      text: "빅 블라인드",
    },
    {
      key: "showAnte",
      data: showAnte,
      setData: setShowAnte,
      label: anteLabel,
      setLabel: setAnteLabel,
      text: "엔티",
    },
    {
      key: "showDuration",
      data: showDuration,
      setData: setShowDuration,
      label: durationLabel,
      setLabel: setDurationLabel,
      text: "시간",
    },
  ];

  const items2 = [
    {
      key: "breakText",
      data: breakText,
      setData: setBreakText,
      text: "브레이크",
    },
    {
      key: "breakTime",
      data: breakTime,
      setData: setBreakTime,
      text: "시간",
    },
  ];

  return (
    <MainInfoWrapper>
      <MainInfoSectionWrapper>
        <MainInfoSectionItem>
          <div className="label">섹션명</div>
        </MainInfoSectionItem>
      </MainInfoSectionWrapper>
      <MainInfoHeader>
        <MainInfoHeaderItem flex={1}>포함여부</MainInfoHeaderItem>
        <MainInfoHeaderItem flex={2}>항목</MainInfoHeaderItem>
        <MainInfoHeaderItem flex={5}>내용 </MainInfoHeaderItem>
      </MainInfoHeader>
      {items.map((item) => (
        <MainInfoContentWrapper key={item.key}>
          <MainInfoContentItem flex={1}>
            <Checkbox
              checked={item.data}
              onChange={() => item.setData(!item.data)}
            />
          </MainInfoContentItem>
          <MainInfoContentItem flex={2}>
            <div className="label">{item.text}</div>
          </MainInfoContentItem>
          <MainInfoContentItem flex={5}>
            <MainInfoContentItemInput
              disabled={!item.data}
              value={item.label}
              onChange={(e) => item.setLabel(e.target.value)}
            />
          </MainInfoContentItem>
        </MainInfoContentWrapper>
      ))}
      <EditLine style={{ marginBottom: "30px" }} />
      {items2.map((item) => (
        <MainInfoContentWrapper key={item.key}>
          <MainInfoContentItem flex={1}></MainInfoContentItem>
          <MainInfoContentItem flex={2}>
            <div className="label">{item.text}</div>
          </MainInfoContentItem>
          <MainInfoContentItem flex={5}>
            <MainInfoContentItemInput
              value={item.data}
              onChange={(e) => item.setData(e.target.value)}
            />
          </MainInfoContentItem>
        </MainInfoContentWrapper>
      ))}
    </MainInfoWrapper>
  );
};

export default Structure;
